module.exports = __webpack_public_path__ + "static/fetola-9de5af0541ac53f24ff4f85b09367d55.png";